<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
<!--      <v-flex xs12 sm10 md8 offset-sm1 offset-md2 mb-2>
        <v-card flat height="22px">
          <v-img
            :src="require('../assets/smallThinNENCBar.png')"
            height="100%"
            contain>
          </v-img>
        </v-card>
      </v-flex>
-->
      <v-flex xs12 sm10 md10 offset-sm1 offset-md1>
        <v-card :class="userElevation">
          <v-toolbar dark color="primary">
            <v-toolbar-title class="title">
            User Profile
            </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-btn
                v-if="!userProfile.mentor && !editMode"
                flat
                outline
                dark
                @click="requestConversion()">
                  Become a Mentor
              </v-btn>
              <v-btn 
                v-if="!editMode"
                flat
                outline
                dark 
                @click="changeMode(true)">
                  Edit
              </v-btn>
            <v-tooltip bottom>
              <v-btn 
                slot="activator"
                flat
                icon
                dark
                @click="showHelp = !showHelp">
                  <v-icon>help_outline</v-icon>
              </v-btn>
              <span v-if="!showHelp">Show help</span>
              <span v-else>Hide help</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-title v-if="showHelp">
            <template>
              <v-layout row wrap>
                <v-flex xs12>
                  <div v-if="userProfile.mentor">
                    <p class="text-xs-left">The information you add here will be used to enable potential mentees to search for a suitable mentor.  The more information you include, the easier it will be for the right mentees to find your profile.  Note that your contact details will not be visible to potential mentees until you have agreed to be their mentor.</p>
                    <p class="text-xs-left">You can also set the number of concurrent mentees you are able to have from here, and if you are currently unable to take on mentees you can make yourself unavailable so that your profile does not appear on any searches.</p>
                  </div>
                  <p class="text-xs-left">The information you add here will help potential mentors to understand your background and what you want from a mentor as well as how they can contact you to discuss your requirements further.</p>
                </v-flex>
              </v-layout>
            </template>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 v-if="userProfile.mentor">
                  <div 
                    v-if="!editMode"
                    class="text-xs-left">
                    <span class="v-label theme--light">
                      <br>{{userProfile.available}} to take on new clients<br><br>
                    </span>
                  </div>
                  <div v-else>
                    <v-switch
                      v-model="userProfile.available"
                      false-value="Unavailable"
                      true-value="Available"
                      :readonly="!editMode"
                      color="primary"
                      name="available"
                      :label="`${userProfile.available} to take on new clients`"
                      id="available">
                    </v-switch>
                  </div>
                </v-flex>

                <v-flex xs6>
                  <v-text-field
                    v-model="userProfile.name"
                    name="userName"
                    label="Name"
                    id="Name"
                    readonly>
                  </v-text-field> 
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    type="email"
                    v-model="userProfile.email"
                    readonly
                    name="userEmail"
                    label="Email"
                    id="Email"
                    required>
                  </v-text-field> 
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="userProfile.telephone"
                    :readonly="!editMode"
                    name="userPhone"
                    label="Telephone"
                    id="Telephone">
                  </v-text-field> 
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :items="configData.locations"
                    v-model="userProfile.location"
                    :readonly="!editMode"
                    name="userLocation"
                    label="Primary Location"
                    id="Location"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :items="employerList"
                    v-model="userProfile.employer"
                    :readonly="!editMode"
                    name="userEmployer"
                    label="Employer"
                    id="Employer"
                  ></v-select>
                </v-flex>
                <v-flex xs4 v-if="userProfile.mentor">
                  <v-text-field
                    type="number"
                    min="1" max="5"
                    v-model="userProfile.clientsLimit"
                    :readonly="!editMode"
                    name="clientsLimit"
                    label="Limit of Concurrent Clients"
                    id="clientsLimit">
                  </v-text-field> 
                </v-flex>
                <v-flex xs4 offset-xs2 v-if="userProfile.mentor">
                  <v-text-field
                    type="number"
                    v-model="userProfile.clientsCurrent"
                    readonly
                    name="clientsCurrent"
                    label="Number of Current Clients"
                    id="clientsCurrent">
                  </v-text-field> 
                </v-flex>

                <v-flex xs12>
                  
                  <v-select
                    :items="configData.roles"
                    v-model="userProfile.role"
                    :readonly="!editMode"
                    hint="Please select your main job role.  Select Clinical Research Practitioner if your main role is not explicitly listed."
                    persistent-hint
                    name="userRole"
                    label="Role"
                    id="Role"
                  ></v-select>
                  <br>
                  <v-select
                    :items="specialtyList"
                    v-model="userProfile.specialty"
                    :readonly="!editMode"
                    multiple
                    hint="Please select ‘I do not have a specific specialty’ if your main role is not specialty based."
                    persistent-hint
                    name="userSpecialty"
                    label="Specialty"
                    id="Specialty"
                  ></v-select>
                  <br>
                  <v-select
                    :items="configData.topics"
                    v-model="userProfile.topics"
                    :readonly="!editMode"
                    multiple
                    hint="Please select the topics that you would either like to receive mentor support on, or that you would like to provide mentor support to others about."
                    persistent-hint
                    name="userTopics"
                    label="Topics"
                    id="Topics"
                  ></v-select>
                  <br>
                  <v-textarea 
                    auto-grow
                    v-model="userProfile.bio" 
                    :readonly="!editMode"
                    placeholder="Please add some information here about your experience and background.  For example previous roles and research experience, research projects that you may have been involved in, and other interests.  This will help potential clients to decide whether you may be a good potential mentor match."
                    label="Background">
                  </v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          
          <v-card-actions v-if="editMode">
            <v-btn 
                flat 
                color="secondary" 
                dark
                @click="saveChanges">Save</v-btn>
            <v-spacer></v-spacer>
            <v-btn 
                flat 
                color="blue darken-1" 
                dark
                @click="cancelChanges">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
     userProfile:{},
      emailRules: [
              v => !!v || 'Email is required',
              v => /^(?:(?:[\w`~!#$%^&*\-=+;:{}'|,?\/]+(?:(?:\.(?:"(?:\\?[\w`~!#$%^&*\-=+;:{}'|,?\/\.()<>\[\] @]|\\"|\\\\)*"|[\w`~!#$%^&*\-=+;:{}'|,?\/]+))*\.[\w`~!#$%^&*\-=+;:{}'|,?\/]+)?)|(?:"(?:\\?[\w`~!#$%^&*\-=+;:{}'|,?\/\.()<>\[\] @]|\\"|\\\\)+"))@(?:[a-zA-Z\d\-]+(?:\.[a-zA-Z\d\-]+)*|\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])$/.test(v) || 'E-mail must be valid'
            ],
      showHelp: false
    }),
    created: function() {
      this.changeMode(false)
      this.loadDataIntoForm()
    },
    computed: {
      userElevation: function () {
        if (this.editMode == true) {
          return "elevation-24"
        } else {
          return "elevation-1"
        }
      },
      myProfile: function() {
        return this.$store.getters.getMyProfile
      },
      editMode: function () {
        //return this.$store.getters.getForms
        return this.$store.getters.getProfileEditMode
      },
      configData: function () {
        //return this.$store.getters.getForms
        return this.$store.getters.getConfig
      },
      specialtyList: function () {
        var noSpecialty = ["I do not have a specific specialty"]
        return noSpecialty.concat(this.configData.specialty) 
      },
      employerList: function () {
        var allEmp = this.configData.employer.filter(employer => employer.location == 'All')
        var locationEmp = this.configData.employer.filter(employer => employer.location == this.userProfile.location)
        var fullEmp = locationEmp.concat(allEmp)

        return fullEmp.map(employer => employer.employer)
      }
    },
    watch: {
      editMode: function () {
        this.loadDataIntoForm()
      }
    },
    methods: {
      cancelChanges() {
        this.$forceUpdate();
//        this.$store.commit('showErrorMessage',{color:"success",message:"Cancelling changes"})
        this.loadDataIntoForm()
        this.changeMode(false)
      },
      saveChanges() {
        this.$forceUpdate();
        this.$store.dispatch("saveMyProfile",this.userProfile)
      },
      loadDataIntoForm() {
        //clear out userProfile before reloading from myProfile
        this.userProfile = {}
        this.userProfile = Object.assign({},this.myProfile)

        //console.log("userProfile after",this.userProfile)

        console.log("Form and profile are the same - ",Object.is(this.myProfile,this.userProfile))
      },
//      removeRole (item) {
  //      this.formData.roles.splice(this.formData.roles.indexOf(item), 1)
    //    //this.formData.roles = [...this.formData.roles]
      //},
      changeMode (toggle) {
        this.$store.commit('setProfileEditMode',toggle)
      },
      requestConversion () {
        console.log("requestConversion")
        this.userProfile.convertRequest = true
        this.saveChanges()
      }
    }
  }
</script>

<style>

</style>
